import axios from 'axios';
import get from 'lodash/get';

const backendModule = {
  namespaced: true,
  state: {
    b2b: true,
    accountConsumerToggleAccess: get(window.ACC, 'accountConsumerToggleAccess', true),
    consumerFriendlyMode: get(window.ACC, 'accountConsumerToggleAccess', true) ? window.ACC.isB2BPriceToggle : true,
    cartToggle: window.ACC.cartToggle || false,
    isAdmin: window.ACC.isAdmin || false,
    contextPath: ACC.config.contextPath || '',
    encodedContextPath: ACC.config.encodedContextPath || '',
    isB2BPurchasable: ACC.isB2BPurchasable || false,
    appleLabelAccess: ACC.appleLabelAccess,
    maxCartItems: ACC.maxCartItems || 950,
    textCheckoutB2BTooManyItems: ACC.textCheckoutB2BTooManyItems || '',
    isDistributor: ACC.isDistributor || false,
    isDropShipFlagEnabled: ACC.isDropShipFlagEnabled || false,
    containerToDelete: null,
  },

  getters: {
    b2b(state) {
      return state.b2b;
    },
    cartToggle(state) {
      return state.cartToggle;
    },
    consumerFriendlyMode(state) {
      return state.consumerFriendlyMode;
    },
  },

  mutations: {
    setB2b(state, value) {
      state.b2b = value;
    },
    setCartToggle(state, value) {
      state.cartToggle = value;
    },
    setConsumerFriendlyMode(state, value) {
      state.consumerFriendlyMode = value;
    },
    setContainerToDelete(state, value) {
      state.containerToDelete = value;
    },
  },

  actions: {
    toggleConsumerFriendlyMode({commit, state}) {
      let value = !state.consumerFriendlyMode;

      axios
        .get(`/my-account/price-toggle?priceToggle=${value}`)
        .then(() => {
          commit('setConsumerFriendlyMode', value);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

export default backendModule;
